/**
 * Coffre auth via Service Worker + Cache API.
 * Sur iOS PWA, localStorage/cookies sont isolés et parfois purgés ;
 * le cache SW est plus fiable dans le mode standalone (cf. Netguru, MDN Storage API).
 */
export const AUTH_VAULT_PATH = "/__mycoaching/auth";

async function waitForController() {
  if (!("serviceWorker" in navigator)) return false;
  try {
    if (navigator.serviceWorker.controller) return true;
    await navigator.serviceWorker.ready;
    return !!navigator.serviceWorker.controller;
  } catch {
    return false;
  }
}

export async function saveAuthVault(payload) {
  if (!payload?.token) return;
  const ready = await waitForController();
  if (!ready) return;
  try {
    await fetch(AUTH_VAULT_PATH, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: payload.token,
        user: payload.user ?? null,
        remember_me: payload.remember_me !== false,
        saved_at: Date.now(),
      }),
    });
  } catch {
    /* ignore */
  }
}

export async function loadAuthVault() {
  const ready = await waitForController();
  if (!ready) return null;
  try {
    const res = await fetch(AUTH_VAULT_PATH);
    if (!res.ok) return null;
    const data = await res.json();
    if (data?.token) return data;
  } catch {
    /* ignore */
  }
  return null;
}

export async function clearAuthVault() {
  const ready = await waitForController();
  if (!ready) return;
  try {
    await fetch(AUTH_VAULT_PATH, { method: "DELETE" });
  } catch {
    /* ignore */
  }
}